export const actionNames = {
  FETCH_TIMEZONES: 'TIME_ZONES:FETCH_TIMEZONES',
  FETCH_TIMEZONES_SUCCESS: 'TIME_ZONES:FETCH_TIMEZONES_SUCCESS',
  FETCH_TIMEZONES_FAILURE: 'TIME_ZONES:FETCH_TIMEZONES_FAILURE',
  FETCH_TIMEZONES_LOADED: 'TIME_ZONES:FETCH_TIMEZONES_LOADED',
}

export const fetchTimezones = () => {
  return {
    type: actionNames.FETCH_TIMEZONES,
  }
}
